import { render, staticRenderFns } from "./TerminalTicketHistoryEmpty.vue?vue&type=template&id=95ef6f5c&scoped=true"
import script from "./TerminalTicketHistoryEmpty.vue?vue&type=script&lang=js"
export * from "./TerminalTicketHistoryEmpty.vue?vue&type=script&lang=js"
import style0 from "./TerminalTicketHistoryEmpty.vue?vue&type=style&index=0&id=95ef6f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef6f5c",
  null
  
)

export default component.exports